import setGrabCursor from './setGrabCursor';
import unsetGrabCursor from './unsetGrabCursor';
export default {
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
};


//////////////////
// WEBPACK FOOTER
// ./~/swiper/esm/components/core/grab-cursor/index.js
// module id = 720
// module chunks = 169